__turbopack_context__.v({
  "content": "SensorFeatures-module__eHqJmq__content",
  "content-reverse": "SensorFeatures-module__eHqJmq__content-reverse",
  "description": "SensorFeatures-module__eHqJmq__description",
  "description-1": "SensorFeatures-module__eHqJmq__description-1",
  "description-2": "SensorFeatures-module__eHqJmq__description-2",
  "highlight": "SensorFeatures-module__eHqJmq__highlight",
  "root": "SensorFeatures-module__eHqJmq__root",
});
